import React, { useCallback, useMemo } from 'react';
import { Heading } from '@common-fe/common-fe';
import { Box } from 'grommet';

import { SpendTracker } from '@/modules/deductibles';
import { useAuthStore } from '@/modules/user';

import { useGetHealthPlanYears } from '../SpendTracker/hooks';

import { TiersModule } from './TiersModule';

interface HealthPlanSpendTrackerDetailsProps {
  healthPlanName?: string;
  yearId?: string;
  onHealthPlanNameChange: (name: string) => void;
}

export const HealthPlanSpendTrackerDetails: React.FC<HealthPlanSpendTrackerDetailsProps> = ({
  healthPlanName,
  yearId,
  onHealthPlanNameChange,
}) => {
  const { user: currentUser } = useAuthStore();
  const { formattedData } = useGetHealthPlanYears(currentUser?.employee?.id);

  const currentPlanYear = useMemo(() => formattedData?.find((item) => item.id == yearId), [formattedData, yearId]);
  const handleHealthPlanNameChange = useCallback((newName: string) => {
    onHealthPlanNameChange(newName);
  }, [onHealthPlanNameChange]);

  return (
    <Box>
      <Heading level={4} size="large" color="textTitle" margin={{ vertical: 'xxs'}}>{healthPlanName}</Heading>
      <SpendTracker
        defaultHealthPlanYearId={currentPlanYear?.id}
        onHealthPlanNameChange={handleHealthPlanNameChange}
        isDetailsPageMode
      />
      <TiersModule />
    </Box>
  );
};
